function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.03815 12.0902H13.0381C13.6823 12.0902 14.0763 11.74 14.0763 11.2147C14.0763 10.5518 13.4759 9.98265 12.9131 9.44482C12.469 9.0133 12.369 8.11273 12.2877 7.28096C12.1876 4.99203 11.5184 3.37852 9.89869 2.79691C9.64228 1.97139 8.9606 1.3335 8.03502 1.3335C7.1157 1.3335 6.43402 1.97139 6.17136 2.79691C4.55785 3.37852 3.88243 4.99203 3.78862 7.28096C3.70732 8.11273 3.601 9.0133 3.16323 9.44482C2.60038 9.98265 2 10.5518 2 11.2147C2 11.74 2.394 12.0902 3.03815 12.0902ZM8.03502 14.6668C9.14822 14.6668 9.95497 13.8726 10.0363 12.9658H6.04003C6.12133 13.8726 6.92808 14.6668 8.03502 14.6668Z",
  fill: "#2B2B2B"
});

function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.42c106f6.svg";
export { ForwardRef as ReactComponent };